module.exports = __webpack_public_path__ + "static/412-72d336d529f47e388a6f52eddc2688f8.png";